<!--
 * @Description: 新闻中心
 * @Author: zml
 * @Date: 2023-07-25 10:54:13
 * @LastEditors: zml
 * @LastEditTime: 2025-05-12 10:47:29
-->
<template>
  <div>
    <div class="container news">
      <div class="title">{{$t('GA.NewsUpdates')}}</div>
      <div class="items" v-for="(item,index) in newsData" :key="index">
        <div class="left" @click="$router.push({path:'/newsDetail',query:{num: item.id}})">
          <img :src="item.imgUrl" :alt="`.`" srcset />
        </div>
        <div class="right">
          <div class="content-title">
            <span
              style="cursor: pointer;"
              @click="$router.push({path:'/newsDetail',query:{num: item.id}})"
            >{{ $hs(item.title,item.enTitle,item.threeTitle) }}</span>
          </div>
          <div class="content">{{$hs(item.description,item.enDescription,item.threeDescription)||''}}</div>
          <div class="date">{{item.createdTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { QueryPage } from '@/api/news'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'newsPage',
  data() {
    return {
      queryParam: {
        pageNo: 1,
        pageSize: 10,
        sortField: '',
        sortOrder: '',
        keywords: ''
      },
      newsData: []
    }
  },
  props: {
    datas: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapGetters('setting', {
      getSetting: 'get_setting'
    })
  },
  created() {
    this.queryPage()
  },
  methods: {
    queryPage() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('GA.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      QueryPage(this.queryParam)
        .then(res => {
          if (res.success) {
            this.newsData = res.data.rows || []
            // this.newsData.forEach(item => {
            //   let date = ''
            //   date = new Date(item.createdTime)
            //   let year = date.getFullYear()
            //   let month = date.getMonth() + 1
            //   let d = date.getDate()
            //   item.createdTime = year + '/' + month + '/' + d
            // })
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
        .finally(() => {
          loading.close()
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.news {
  .title {
    font-size: 30px;
    font-weight: 700;
    color: #333c4f;
    margin: 40px 0 20px;
  }
}

.items {
  display: flex;
  height: 205px;
  padding: 30px 0 25px;
  box-sizing: border-box;
  border-bottom: 1px solid #d5d5d5;
  .left {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 192px;
    height: 150px;
    box-shadow: 0 0 10px 2px #ececec;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 10px 6px #eee;
    }
    img {
      max-width: 192px;
      max-height: 150px;
    }
  }
  .right {
    flex: 1;
    font-size: 16px;
    padding: 0 20px;
    box-sizing: border-box;
    .content-title {
      width: 950px;
      height: 69px;
      line-height: 69px;
      font-size: 22px;
      color: #222222;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .content {
      height: 21px;
      width: 950px;
      font-size: 16px;
      color: #222222;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .date {
      margin: 20px 0 0 0;
      color: #b2b2b2;
    }
  }
}
</style>
